export function SET_SELECTED_ROW (state, payload) {
  state.selectedRow = payload
}

export const SET_VALUE = (state, [key, value]) => {
  state[key] = value
}

export const SET_IMAGES = (state, payload) => {
  state.form.images = payload.map(() => {
    return {}
  })

  setTimeout(() => {
    state.form.images.forEach((item, index) => {
      state.form.images[index] = payload[index]
    })
  }, 500)
}

export const PUSH_IMAGES = (state, payload) => {
  state.form.images.push(payload)
}

export const UPDATE_IMAGE = (state, [value, index]) => {
  state.form.images[index] = value
}

export const REMOVE_IMAGE = (state, index) => {
  state.form.images.splice(index, 1)
}

export const SET_FORM_MULTIPLE = (state, payload) => {
  Object.keys(state.formDefault).forEach(item => {
    state.form[item] = payload[item]
  })
}

export const RESET_FORM = (state, payload) => {
  state.form = JSON.parse(JSON.stringify(state.formDefault))
}

// ------------
// FORM
// ------------
export const SET_FORM_VALUE = (state, [key, value]) => {
  state.form[key] = value
}

export const SET_PUSH_VARIANT = (state, payload) => {
  state.form.variants.push({
    type: {
      label: null,
      isNew: true
    },
    children: []
  })
}

export const SET_VARIANT_TYPE = (state, [value, index]) => {
  state.form.variants[index].type = value
}

export const SET_VARIANT = (state, [value, index]) => {
  state.form.variants[index] = value
}

export const REMOVE_VARIANT = (state, index) => {
  state.form.variants.splice(index, 1)
}

export const SET_CATEGORY_VALUE = (state, [key, value]) => {
  state.form[key].value = value
}
